module.exports = __webpack_public_path__ + "img/welcomes-preview-bag-fanli-2.a5363379.png";